export default {"src":"/_next/static/media/cover1.a83928da.svg","height":560,"width":1440,"blurWidth":0,"blurHeight":0};